/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SlugRouteImport } from './routes/$slug'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as DatenschutzRouteImport } from './routes/datenschutz'
import { Route as GalerieRouteImport } from './routes/galerie'
import { Route as IconLeagueRouteImport } from './routes/icon-league'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as KalenderRouteImport } from './routes/kalender'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as MitgliedWerdenRouteImport } from './routes/mitglied-werden'
import { Route as ProfilRouteImport } from './routes/profil'
import { Route as RegistrationSuccessRouteImport } from './routes/registration-success'
import { Route as UberUnsRouteImport } from './routes/uber-uns'
import { Route as AktivitaetenIndexRouteImport } from './routes/aktivitaeten/index'
import { Route as AktivitaetenSlugRouteImport } from './routes/aktivitaeten/$slug'
import { Route as EventsIndexRouteImport } from './routes/events/index'
import { Route as EventsEventIdRouteImport } from './routes/events/$eventId'
import { Route as TicketsIndexRouteImport } from './routes/tickets/index'
import { Route as TicketsEventIdRouteImport } from './routes/tickets/$eventId'
import { Route as VereinIndexRouteImport } from './routes/verein/index'
import { Route as VereinSatzungRouteImport } from './routes/verein/satzung'
import { Route as VereinVorstandRouteImport } from './routes/verein/vorstand'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SlugRoute = SlugRouteImport.update({
  id: '/$slug',
  path: '/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const DatenschutzRoute = DatenschutzRouteImport.update({
  id: '/datenschutz',
  path: '/datenschutz',
  getParentRoute: () => rootRouteImport,
} as any)
const GalerieRoute = GalerieRouteImport.update({
  id: '/galerie',
  path: '/galerie',
  getParentRoute: () => rootRouteImport,
} as any)
const IconLeagueRoute = IconLeagueRouteImport.update({
  id: '/icon-league',
  path: '/icon-league',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpressumRoute = ImpressumRouteImport.update({
  id: '/impressum',
  path: '/impressum',
  getParentRoute: () => rootRouteImport,
} as any)
const KalenderRoute = KalenderRouteImport.update({
  id: '/kalender',
  path: '/kalender',
  getParentRoute: () => rootRouteImport,
} as any)
const KontaktRoute = KontaktRouteImport.update({
  id: '/kontakt',
  path: '/kontakt',
  getParentRoute: () => rootRouteImport,
} as any)
const MitgliedWerdenRoute = MitgliedWerdenRouteImport.update({
  id: '/mitglied-werden',
  path: '/mitglied-werden',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfilRoute = ProfilRouteImport.update({
  id: '/profil',
  path: '/profil',
  getParentRoute: () => rootRouteImport,
} as any)
const RegistrationSuccessRoute = RegistrationSuccessRouteImport.update({
  id: '/registration-success',
  path: '/registration-success',
  getParentRoute: () => rootRouteImport,
} as any)
const UberUnsRoute = UberUnsRouteImport.update({
  id: '/uber-uns',
  path: '/uber-uns',
  getParentRoute: () => rootRouteImport,
} as any)
const AktivitaetenIndexRoute = AktivitaetenIndexRouteImport.update({
  id: '/aktivitaeten/',
  path: '/aktivitaeten/',
  getParentRoute: () => rootRouteImport,
} as any)
const AktivitaetenSlugRoute = AktivitaetenSlugRouteImport.update({
  id: '/aktivitaeten/$slug',
  path: '/aktivitaeten/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsIndexRoute = EventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEventIdRoute = EventsEventIdRouteImport.update({
  id: '/events/$eventId',
  path: '/events/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsIndexRoute = TicketsIndexRouteImport.update({
  id: '/tickets/',
  path: '/tickets/',
  getParentRoute: () => rootRouteImport,
} as any)
const TicketsEventIdRoute = TicketsEventIdRouteImport.update({
  id: '/tickets/$eventId',
  path: '/tickets/$eventId',
  getParentRoute: () => rootRouteImport,
} as any)
const VereinIndexRoute = VereinIndexRouteImport.update({
  id: '/verein/',
  path: '/verein/',
  getParentRoute: () => rootRouteImport,
} as any)
const VereinSatzungRoute = VereinSatzungRouteImport.update({
  id: '/verein/satzung',
  path: '/verein/satzung',
  getParentRoute: () => rootRouteImport,
} as any)
const VereinVorstandRoute = VereinVorstandRouteImport.update({
  id: '/verein/vorstand',
  path: '/verein/vorstand',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/changelog': typeof ChangelogRoute
  '/datenschutz': typeof DatenschutzRoute
  '/galerie': typeof GalerieRoute
  '/icon-league': typeof IconLeagueRoute
  '/impressum': typeof ImpressumRoute
  '/kalender': typeof KalenderRoute
  '/kontakt': typeof KontaktRoute
  '/mitglied-werden': typeof MitgliedWerdenRoute
  '/profil': typeof ProfilRoute
  '/registration-success': typeof RegistrationSuccessRoute
  '/uber-uns': typeof UberUnsRoute
  '/aktivitaeten/$slug': typeof AktivitaetenSlugRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/tickets/$eventId': typeof TicketsEventIdRoute
  '/verein/satzung': typeof VereinSatzungRoute
  '/verein/vorstand': typeof VereinVorstandRoute
  '/aktivitaeten/': typeof AktivitaetenIndexRoute
  '/events/': typeof EventsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/verein/': typeof VereinIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/changelog': typeof ChangelogRoute
  '/datenschutz': typeof DatenschutzRoute
  '/galerie': typeof GalerieRoute
  '/icon-league': typeof IconLeagueRoute
  '/impressum': typeof ImpressumRoute
  '/kalender': typeof KalenderRoute
  '/kontakt': typeof KontaktRoute
  '/mitglied-werden': typeof MitgliedWerdenRoute
  '/profil': typeof ProfilRoute
  '/registration-success': typeof RegistrationSuccessRoute
  '/uber-uns': typeof UberUnsRoute
  '/aktivitaeten/$slug': typeof AktivitaetenSlugRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/tickets/$eventId': typeof TicketsEventIdRoute
  '/verein/satzung': typeof VereinSatzungRoute
  '/verein/vorstand': typeof VereinVorstandRoute
  '/aktivitaeten': typeof AktivitaetenIndexRoute
  '/events': typeof EventsIndexRoute
  '/tickets': typeof TicketsIndexRoute
  '/verein': typeof VereinIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$slug': typeof SlugRoute
  '/changelog': typeof ChangelogRoute
  '/datenschutz': typeof DatenschutzRoute
  '/galerie': typeof GalerieRoute
  '/icon-league': typeof IconLeagueRoute
  '/impressum': typeof ImpressumRoute
  '/kalender': typeof KalenderRoute
  '/kontakt': typeof KontaktRoute
  '/mitglied-werden': typeof MitgliedWerdenRoute
  '/profil': typeof ProfilRoute
  '/registration-success': typeof RegistrationSuccessRoute
  '/uber-uns': typeof UberUnsRoute
  '/aktivitaeten/$slug': typeof AktivitaetenSlugRoute
  '/events/$eventId': typeof EventsEventIdRoute
  '/tickets/$eventId': typeof TicketsEventIdRoute
  '/verein/satzung': typeof VereinSatzungRoute
  '/verein/vorstand': typeof VereinVorstandRoute
  '/aktivitaeten/': typeof AktivitaetenIndexRoute
  '/events/': typeof EventsIndexRoute
  '/tickets/': typeof TicketsIndexRoute
  '/verein/': typeof VereinIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$slug'
    | '/changelog'
    | '/datenschutz'
    | '/galerie'
    | '/icon-league'
    | '/impressum'
    | '/kalender'
    | '/kontakt'
    | '/mitglied-werden'
    | '/profil'
    | '/registration-success'
    | '/uber-uns'
    | '/aktivitaeten/$slug'
    | '/events/$eventId'
    | '/tickets/$eventId'
    | '/verein/satzung'
    | '/verein/vorstand'
    | '/aktivitaeten/'
    | '/events/'
    | '/tickets/'
    | '/verein/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$slug'
    | '/changelog'
    | '/datenschutz'
    | '/galerie'
    | '/icon-league'
    | '/impressum'
    | '/kalender'
    | '/kontakt'
    | '/mitglied-werden'
    | '/profil'
    | '/registration-success'
    | '/uber-uns'
    | '/aktivitaeten/$slug'
    | '/events/$eventId'
    | '/tickets/$eventId'
    | '/verein/satzung'
    | '/verein/vorstand'
    | '/aktivitaeten'
    | '/events'
    | '/tickets'
    | '/verein'
  id:
    | '__root__'
    | '/'
    | '/$slug'
    | '/changelog'
    | '/datenschutz'
    | '/galerie'
    | '/icon-league'
    | '/impressum'
    | '/kalender'
    | '/kontakt'
    | '/mitglied-werden'
    | '/profil'
    | '/registration-success'
    | '/uber-uns'
    | '/aktivitaeten/$slug'
    | '/events/$eventId'
    | '/tickets/$eventId'
    | '/verein/satzung'
    | '/verein/vorstand'
    | '/aktivitaeten/'
    | '/events/'
    | '/tickets/'
    | '/verein/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SlugRoute: typeof SlugRoute
  ChangelogRoute: typeof ChangelogRoute
  DatenschutzRoute: typeof DatenschutzRoute
  GalerieRoute: typeof GalerieRoute
  IconLeagueRoute: typeof IconLeagueRoute
  ImpressumRoute: typeof ImpressumRoute
  KalenderRoute: typeof KalenderRoute
  KontaktRoute: typeof KontaktRoute
  MitgliedWerdenRoute: typeof MitgliedWerdenRoute
  ProfilRoute: typeof ProfilRoute
  RegistrationSuccessRoute: typeof RegistrationSuccessRoute
  UberUnsRoute: typeof UberUnsRoute
  AktivitaetenSlugRoute: typeof AktivitaetenSlugRoute
  EventsEventIdRoute: typeof EventsEventIdRoute
  TicketsEventIdRoute: typeof TicketsEventIdRoute
  VereinSatzungRoute: typeof VereinSatzungRoute
  VereinVorstandRoute: typeof VereinVorstandRoute
  AktivitaetenIndexRoute: typeof AktivitaetenIndexRoute
  EventsIndexRoute: typeof EventsIndexRoute
  TicketsIndexRoute: typeof TicketsIndexRoute
  VereinIndexRoute: typeof VereinIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$slug': {
      id: '/$slug'
      path: '/$slug'
      fullPath: '/$slug'
      preLoaderRoute: typeof SlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/datenschutz': {
      id: '/datenschutz'
      path: '/datenschutz'
      fullPath: '/datenschutz'
      preLoaderRoute: typeof DatenschutzRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/galerie': {
      id: '/galerie'
      path: '/galerie'
      fullPath: '/galerie'
      preLoaderRoute: typeof GalerieRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/icon-league': {
      id: '/icon-league'
      path: '/icon-league'
      fullPath: '/icon-league'
      preLoaderRoute: typeof IconLeagueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impressum': {
      id: '/impressum'
      path: '/impressum'
      fullPath: '/impressum'
      preLoaderRoute: typeof ImpressumRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kalender': {
      id: '/kalender'
      path: '/kalender'
      fullPath: '/kalender'
      preLoaderRoute: typeof KalenderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/kontakt': {
      id: '/kontakt'
      path: '/kontakt'
      fullPath: '/kontakt'
      preLoaderRoute: typeof KontaktRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mitglied-werden': {
      id: '/mitglied-werden'
      path: '/mitglied-werden'
      fullPath: '/mitglied-werden'
      preLoaderRoute: typeof MitgliedWerdenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profil': {
      id: '/profil'
      path: '/profil'
      fullPath: '/profil'
      preLoaderRoute: typeof ProfilRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/registration-success': {
      id: '/registration-success'
      path: '/registration-success'
      fullPath: '/registration-success'
      preLoaderRoute: typeof RegistrationSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/uber-uns': {
      id: '/uber-uns'
      path: '/uber-uns'
      fullPath: '/uber-uns'
      preLoaderRoute: typeof UberUnsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aktivitaeten/': {
      id: '/aktivitaeten/'
      path: '/aktivitaeten'
      fullPath: '/aktivitaeten/'
      preLoaderRoute: typeof AktivitaetenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/aktivitaeten/$slug': {
      id: '/aktivitaeten/$slug'
      path: '/aktivitaeten/$slug'
      fullPath: '/aktivitaeten/$slug'
      preLoaderRoute: typeof AktivitaetenSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/': {
      id: '/events/'
      path: '/events'
      fullPath: '/events/'
      preLoaderRoute: typeof EventsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$eventId': {
      id: '/events/$eventId'
      path: '/events/$eventId'
      fullPath: '/events/$eventId'
      preLoaderRoute: typeof EventsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/': {
      id: '/tickets/'
      path: '/tickets'
      fullPath: '/tickets/'
      preLoaderRoute: typeof TicketsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tickets/$eventId': {
      id: '/tickets/$eventId'
      path: '/tickets/$eventId'
      fullPath: '/tickets/$eventId'
      preLoaderRoute: typeof TicketsEventIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verein/': {
      id: '/verein/'
      path: '/verein'
      fullPath: '/verein/'
      preLoaderRoute: typeof VereinIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verein/satzung': {
      id: '/verein/satzung'
      path: '/verein/satzung'
      fullPath: '/verein/satzung'
      preLoaderRoute: typeof VereinSatzungRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verein/vorstand': {
      id: '/verein/vorstand'
      path: '/verein/vorstand'
      fullPath: '/verein/vorstand'
      preLoaderRoute: typeof VereinVorstandRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SlugRoute: SlugRoute,
  ChangelogRoute: ChangelogRoute,
  DatenschutzRoute: DatenschutzRoute,
  GalerieRoute: GalerieRoute,
  IconLeagueRoute: IconLeagueRoute,
  ImpressumRoute: ImpressumRoute,
  KalenderRoute: KalenderRoute,
  KontaktRoute: KontaktRoute,
  MitgliedWerdenRoute: MitgliedWerdenRoute,
  ProfilRoute: ProfilRoute,
  RegistrationSuccessRoute: RegistrationSuccessRoute,
  UberUnsRoute: UberUnsRoute,
  AktivitaetenSlugRoute: AktivitaetenSlugRoute,
  EventsEventIdRoute: EventsEventIdRoute,
  TicketsEventIdRoute: TicketsEventIdRoute,
  VereinSatzungRoute: VereinSatzungRoute,
  VereinVorstandRoute: VereinVorstandRoute,
  AktivitaetenIndexRoute: AktivitaetenIndexRoute,
  EventsIndexRoute: EventsIndexRoute,
  TicketsIndexRoute: TicketsIndexRoute,
  VereinIndexRoute: VereinIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
